import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {
	const logoSliders = document.querySelectorAll('.logo-slider .logos-swiper');

	logoSliders.forEach((logoSlider) => {
		const logoSection = logoSlider.closest('.logo-slider');
		const prevBtn = logoSection?.querySelector('.logo-prev');
		const nextBtn = logoSection?.querySelector('.logo-next');
		const wrapper = logoSlider.querySelector('.swiper-wrapper');
		const originalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

		if (!originalSlides.length || !prevBtn || !nextBtn) return;

		// Swiper v12 loop moves DOM nodes to create infinite scroll. It needs
		// slides.length >= slidesPerView + loopBuffer at all breakpoints.
		// Max slidesPerView is 5; pad to 15 so the buffer is always satisfied.
		const MIN_SLIDES = 15;
		if (originalSlides.length < MIN_SLIDES) {
			let i = 0;
			while (wrapper.querySelectorAll('.swiper-slide').length < MIN_SLIDES) {
				wrapper.appendChild(originalSlides[i % originalSlides.length].cloneNode(true));
				i++;
			}
		}

		new Swiper(logoSlider, {
			modules: [Navigation],
			loop: true,
			slidesPerGroup: 1,
			breakpoints: {
				0:    { slidesPerView: 2, spaceBetween: 20 },
				768:  { slidesPerView: 3, spaceBetween: 30 },
				1024: { slidesPerView: 5, spaceBetween: 40 },
			},
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
			on: {
				lock() {
					[prevBtn, nextBtn].forEach(btn => {
						btn.style.opacity = '0.5';
						btn.disabled = true;
					});
				},
				unlock() {
					[prevBtn, nextBtn].forEach(btn => {
						btn.style.opacity = '';
						btn.disabled = false;
					});
				},
			},
		});
	});
});
